const TicketsScannerTicketItems = ({ ticketItems }) => {
  const items = ticketItems.map((item) => (
    <li key={item.name}>
      {item.name} x {item.amount}
    </li>
  ))

  return (
    <div>
      <ul>{items}</ul>
    </div>
  )
}

export default TicketsScannerTicketItems
